/* Sweat X product page: gallery, plan + frequency, quantity, add to cart, sticky phone bar. Data: window.SXP */
(() => {
  const P = window.SXP;
  const money = c => '$' + (c / 100).toFixed(2);
  const box = document.querySelector('[data-pbox]');
  const freq = box.querySelector('[data-freq]');
  const qtyIn = box.querySelector('[data-qtyin]');
  const buyBtn = box.querySelector('[data-pbuy]');
  const toast = document.querySelector('[data-added]');
  let t;

  const picked = () => (freq ? P.plans.find(p => String(p.id) === freq.value) : null) || P.plans[0];
  const plan = () => { const r = box.querySelector('input[name="plan"]:checked'); return r && r.value === 'sub' ? picked() : null; };
  const pct = p => Math.round(100 - p.cents * 100 / P.cents);
  const qty = () => Math.max(1, Math.min(20, parseInt(qtyIn.value, 10) || 1));
  const unit = () => (plan() ? plan().cents : P.cents);

  function render(){
    const sub = box.querySelector('[data-row="sub"]'), once = box.querySelector('[data-row="once"]');
    if (sub && P.plans.length) { const pp = picked(); sub.innerHTML = pp.cents < P.cents ? `${money(pp.cents)}<s>${money(P.cents)}</s>` : money(pp.cents); }
    const pe = box.querySelector('[data-pct]'); if (pe && P.plans.length) { const n = pct(picked()); pe.parentNode.firstChild.textContent = n > 0 ? 'Subscribe & save ' : 'Subscribe'; pe.textContent = n > 0 ? n : ''; pe.nextSibling.textContent = n > 0 ? '%' : ''; }
    if (once) once.innerHTML = P.was && P.was > P.cents ? `${money(P.cents)}<s>${money(P.was)}</s>` : money(P.cents);
    const cx = box.querySelector('[data-cx]'); if (cx) cx.hidden = !plan();
    if (P.available) buyBtn.textContent = (plan() ? 'Subscribe' : 'Add to cart') + ' · ' + money(unit() * qty());
    const sp = document.querySelector('[data-s-price]'); if (sp) sp.textContent = money(unit());
    const sl = document.querySelector('[data-s-plan]'); if (sl) sl.textContent = plan() ? (pct(plan()) > 0 ? 'Subscribe & save ' + pct(plan()) + '%' : 'Subscribe') + ', every ' + plan().label : 'One-time purchase';
  }

  function say(html, ms){ toast.innerHTML = html; toast.classList.add('on'); clearTimeout(t); t = setTimeout(() => toast.classList.remove('on'), ms || 4000); }

  function add(items, label, btn){
    const old = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
    return fetch(P.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
      .then(r => r.ok ? r.json() : r.json().then(j => Promise.reject(j)))
      .then(() => fetch(P.cartJs).then(r => r.json()))
      .then(cart => {
        document.querySelectorAll('[data-cart]').forEach(el => el.textContent = cart.item_count);
        const cb = document.querySelector('[data-cartbtn]'); if (cb) cb.setAttribute('aria-label', 'Cart, items: ' + cart.item_count);
        say('Added: ' + label + ' <a href="' + P.cartUrl + '">View cart</a>');
      })
      .catch(err => say((err && (err.description || err.message)) || 'Could not add to cart. Please try again.'))
      .finally(() => { btn.disabled = false; btn.textContent = old; render(); });
  }

  function buy(btn){
    if (!P.available) return;
    const p = plan(), n = qty();
    const item = Object.assign({ id: P.id, quantity: n }, p ? { selling_plan: p.id } : {});
    add([item], (n > 1 ? n + ' × ' : '') + P.name + (p ? ', every ' + p.label : '') + ', ' + money(unit() * n), btn);
  }

  /* gallery */
  const main = document.querySelector('[data-gal-main]') || document.querySelector('.px-main img');
  const ths = [...document.querySelectorAll('.px-th')];
  function show(b){
    if (!main || !b) return;
    main.removeAttribute('srcset'); main.src = b.dataset.src; main.srcset = b.dataset.srcset; main.alt = b.dataset.alt;
    ths.forEach(x => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    const row = b.parentNode; if (row.scrollWidth > row.clientWidth) row.scrollTo({ left: b.offsetLeft - row.clientWidth / 2 + b.offsetWidth / 2, behavior: 'smooth' });
  }
  const step = d => { const i = ths.findIndex(x => x.getAttribute('aria-pressed') === 'true'); show(ths[((i < 0 ? 0 : i) + d + ths.length) % ths.length]); };
  ths.forEach(b => b.addEventListener('click', () => show(b)));
  document.querySelectorAll('.px-main [data-gstep]').forEach(b => { b.hidden = ths.length < 2; b.addEventListener('click', () => step(Number(b.dataset.gstep))); });
  const pm = document.querySelector('.px-main');
  if (pm && ths.length > 1) {   /* swipe the main photo on phones */
    let x0 = null, y0 = 0;
    pm.addEventListener('pointerdown', e => { x0 = e.clientX; y0 = e.clientY; });
    pm.addEventListener('pointerup', e => { if (x0 === null) return; const dx = e.clientX - x0, dy = e.clientY - y0; x0 = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1); });
  }

  /* choices */
  box.addEventListener('change', e => {
    if (e.target === freq) { const s = box.querySelector('input[value="sub"]'); if (s) s.checked = true; }
    render();
  });
  if (freq) freq.addEventListener('click', e => e.stopPropagation());
  /* 30 / 60 / 90 day buttons drive the hidden plan select (Michael 2026-10-31) */
  box.querySelectorAll('[data-fqp]').forEach(b => b.addEventListener('click', e => {
    e.preventDefault(); e.stopPropagation(); freq.value = b.dataset.fqp;
    box.querySelectorAll('[data-fqp]').forEach(x => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    freq.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  box.querySelectorAll('[data-qty]').forEach(b => b.addEventListener('click', () => { qtyIn.value = qty() + Number(b.dataset.qty); qtyIn.value = qty(); render(); }));
  qtyIn.addEventListener('input', render);
  qtyIn.addEventListener('blur', () => { qtyIn.value = qty(); render(); });
  buyBtn.addEventListener('click', () => buy(buyBtn));

  /* bundle page: add the stain remover on its own */
  const up = document.querySelector('[data-upsell]');
  if (up && P.upsell) up.addEventListener('click', () => add([{ id: P.upsell.id, quantity: 1 }], P.upsell.name + ', ' + money(P.upsell.cents), up));

  /* sticky phone bar: shows once the buy box scrolls away */
  const bar = document.querySelector('[data-psticky]');
  if (bar) {
    new IntersectionObserver(([e]) => bar.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(box);
    bar.addEventListener('click', () => buy(bar));
  }

  render();
})();
